import { DatePicker, Steps, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { clear_cart } from "../../actions/orders/Action";
import {
  CreateOrder,
  create_orders,
  DeleteItemFromCart,
  GetCart,
  get_addresses,
  get_cart,
  get_origins,
} from "../../actions/orders";
import {
  customerPaymentTerms,
  customerShipmentTerms,
} from "../../actions/shipmentNPayment";
import Close from "../../assets/cancel.svg";
import PopupComponent from "../../common/Popup";
import { amountFormat } from "../../config/helper";
import Input from "../../form-components/Input";
import { NavWrap } from "../ShopForTyres";
// import Address from "./Address";
import "./cart.css";
import Confirm from "./Confirm";
import Products from "./Products";
import Summary from "./Summary";
import OriginSummary from "./OriginSummary";
import { user_profile } from "../../actions/auth/Action";
import { hasOnlyView } from "../../config/helper";
import check from "../../assets/check.svg";
import termsNConditions from "../../assets/Terms_Conditions_of_Sale.pdf";
import _ from "lodash";

export const ContainerStatus = (props) => {
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  const regions = useSelector((state) => state?.orders?.origins?.data || []);
  const dispatch = useDispatch();

  const [containerStatusByOrigin, setContainerStatusByOrigin] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const addressesByOrigin = useSelector(
  (state) => state?.orders?.addresses?.data || {}
);
const [shippingAddresses, setShippingAddresses] = useState({});
const areAllDestinationsSelected = cart?.line_items?.every(
  (o) => shippingAddresses?.[o.origin_id]
);
const isOriginValid = (originId) => {
  return (
    !!shippingAddresses?.[originId] &&
    !!props.shipmentDate
  );
};
const uniqueDestinations = _.uniqBy(
  (Array.isArray(props.destinationsByOrigin)
    ? props.destinationsByOrigin
    : []
  ).filter(d => ["41", "42"].includes(d?.vtweg)),
  "kunn2"
);

const destinations = Array.isArray(props.destinationsByOrigin)
  ? props.destinationsByOrigin
  : [];

  const normalizeOrderType = (type) =>
  type?.toLowerCase() === "ftl" ? "ftl" : "fd";

  const getCapacityHeader = (type) =>
    normalizeOrderType(type) === "ftl"
      ? "FULL TRUCK CAPACITY"
      : "CONTAINER CAPACITY";

  const getCapacityUnit = (type) =>
    normalizeOrderType(type) === "ftl"
      ? "53 HC Truck"
      : "40 HC Container";


    const getOriginOrderType = () => {
      if (props.fromBulk) return props.order_type;
      return props.origin?.order_type;
    };

    const effectiveOrderType = normalizeOrderType(getOriginOrderType());




  /* HELPERS */
  const getOriginName = (originId) => {
    if (originId === "Bulk") return "Bulk Order";
    const origin = regions.find((r) => r.id === originId);
    return origin?.name || originId;
  };

  useEffect(() => {
  dispatch(
    get_addresses({
      email: localStorage.getItem("email"),
    })
  );
}, [dispatch]);

  /* BUILD DATA (BULK + CART) */
  useEffect(() => {
    let byOrigin = {};

    /*  BULK FLOW */
    if (props.fromBulk) {
      if (!props.table?.rows?.length) {
        setContainerStatusByOrigin({});
        return;
      }

      props.table.rows.forEach((row) => {
        const originId = row[1]?.trim() || "Bulk";
        const qty = Number(row[5]);
        const qpc = Number(row[6]);
        if (!byOrigin[originId]) {
          byOrigin[originId] = {
            items: [],
            itemCount: 0,
            orderType: props.order_type?.toLowerCase() || "fd",
            foot40: [],
          };
        }

        byOrigin[originId].items.push(row);
        if (qty > 0) byOrigin[originId].itemCount += 1;
      });

      Object.keys(byOrigin).forEach((originId) => {
        let container_status = 0;

        byOrigin[originId].items.forEach((row) => {
          const qty = Number(row[5]);
          const qpc = Number(row[6]);
          if (!qty || !qpc) return;

          container_status +=
            byOrigin[originId].orderType === "ftl"
              ? (qty * 100) / (qpc * 1.45)
              : (qty * 100) / qpc;
        });

        while (container_status > 100) {
          byOrigin[originId].foot40.push(100);
          container_status -= 100;
        }
        if (container_status > 0)
          byOrigin[originId].foot40.push(Math.ceil(container_status));

        byOrigin[originId].foot40.reverse();
      });
    }

    /* CART FLOW */
    else {
      if (!cart?.line_items?.length) {
        // create a default "empty" origin so the UI still renders
        const emptyOriginId = "EMPTY";
        setContainerStatusByOrigin({
          [emptyOriginId]: {
            foot40: [0],  // empty container bar
            itemCount: 0,
            orderType: normalizeOrderType(cart?.line_items?.[0]?.order_type),
          },
        });
        return;
      }

      cart.line_items.forEach((origin) => {
        let container_status = 0;

        origin.items?.forEach((item) => {
          const qty = Number(item.Quantity);
          const qpc = Number(item.qpc);
          if (!qty || !qpc) return;

          container_status +=
            origin.order_type?.toLowerCase() === "ftl"
              ? (qty * 100) / (qpc * 1.45)
              : (qty * 100) / qpc;
        });

        const foot40 = [];
        while (container_status > 100) {
          foot40.push(100);
          container_status -= 100;
        }
        if (container_status > 0)
          foot40.push(Math.ceil(container_status));

        byOrigin[origin.origin_id] = {
          foot40: foot40.reverse(),
          itemCount:
            origin.items?.filter((i) => Number(i.Quantity) > 0).length || 0,
          orderType: origin.order_type?.toLowerCase() || "fd",
        };
      });
    }

    setContainerStatusByOrigin(byOrigin);
  }, [cart, props.table, props.fromBulk, props.order_type]);

  const activeOriginId = props.fromBulk
  ? Object.keys(containerStatusByOrigin)[0]   // bulk → first origin
  : props.origin?.origin_id;                  // cart → current origin

const data = containerStatusByOrigin?.[activeOriginId];
const originId = String(props.origin?.origin_id || "");

const allAddresses =
  Array.isArray(props.destinationsByOrigin)
    ? props.destinationsByOrigin
    : Array.isArray(props.destinationsByOrigin?.addresses)
    ? props.destinationsByOrigin.addresses
    : [];

const destinationList = allAddresses.filter(
  (d) =>
    d.partner_fun === "SH" &&
    String(d.vtweg) === String(props.origin?.vtweg)
);




return (
  <div className="container-capacity">

    {/* BULK FLOW  */}
    {props.fromBulk &&
      Object.keys(containerStatusByOrigin).map((originId) => {
        const data = containerStatusByOrigin[originId];

        if (!data) return null;

        return (
          <div className="container-card" key={originId}>
            <h3 className="flex-between">
              {getCapacityHeader(data.orderType)}
            </h3>

            {/* Origin Name */}
            <h4 style={{ marginBottom: "0.75rem", fontWeight: 400, color: "#333" }}>
              {getOriginName(originId)
                ? `Shipped from ${getOriginName(originId)}`
                : "Shipped from —"}
            </h4>

            {/* Capacity Bars */}
        <div>
          {data.foot40?.slice(0, 5)?.map((ft40, idx) => (
            <div key={idx} className="boxes">
              <div>
                <span className={`${ft40 > 10 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 10 && ft40 > 0
                        ? {
                            width: ft40 * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 20 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 20 && ft40 > 10
                        ? {
                            width: (ft40 - 10) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 30 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 30 && ft40 > 20
                        ? {
                            width: (ft40 - 20) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 40 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 40 && ft40 > 30
                        ? {
                            width: (ft40 - 30) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 50 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 50 && ft40 > 40
                        ? {
                            width: (ft40 - 40) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 60 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 60 && ft40 > 50
                        ? {
                            width: (ft40 - 50) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 70 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 70 && ft40 > 60
                        ? {
                            width: (ft40 - 60) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 80 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 80 && ft40 > 70
                        ? {
                            width: (ft40 - 70) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 90 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 90 && ft40 > 80
                        ? {
                            width: (ft40 - 80) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 >= 100 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 < 100 && ft40 > 90
                        ? {
                            width: (ft40 - 90) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>
              </div>

              <strong>
              {getCapacityUnit(data.orderType || effectiveOrderType)}{" "}
                ({ft40}%)
              </strong>
            </div>
          ))}

          {/* MORE CONTAINERS */}
          {data.foot40.length > 5 && (
            <div className="boxes">
              <div>
                <b>{data.foot40.length - 5}</b>
                <label>More Containers filled</label>
              </div>
            </div>
          )}
        </div>

            {/* Footer */}
        {props.showFooter && (
          <div className="boxes mt1 mb1">
            <div>
              <label>No of items - </label>
              <b>{data.itemCount}</b>
            </div>
            <div>
              <label>No of Containers - </label>
              <b>{data.foot40.length}</b>
            </div>
          </div>
        )}
          </div>
        );
      })}

    {/* CART FLOW (UNTOUCHED) */}
    {!props.fromBulk && (() => {
      const data =
        containerStatusByOrigin?.[props.origin?.origin_id];

      if (!data) return null;

    return (
      <div>
        <div className="flex-between">
          <h3 className="flex-between">
              {props.headerOverride || getCapacityHeader(effectiveOrderType)}
          </h3>
        </div>

        {/* ORIGIN NAME */}
        <h4 style={{ marginBottom: "0.75rem", fontWeight: 600, color: "#333" }}>
          Shipped from {props.origin.origin_name}
        </h4>

        {/* CONTAINER BOXES (SAME OLD LOGIC) */}
        <div>
          {data.foot40?.slice(0, 5)?.map((ft40, idx) => (
            <div key={idx} className="boxes">
              <div>
                <span className={`${ft40 > 10 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 10 && ft40 > 0
                        ? {
                            width: ft40 * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 20 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 20 && ft40 > 10
                        ? {
                            width: (ft40 - 10) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 30 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 30 && ft40 > 20
                        ? {
                            width: (ft40 - 20) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 40 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 40 && ft40 > 30
                        ? {
                            width: (ft40 - 30) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 50 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 50 && ft40 > 40
                        ? {
                            width: (ft40 - 40) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 60 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 60 && ft40 > 50
                        ? {
                            width: (ft40 - 50) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 70 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 70 && ft40 > 60
                        ? {
                            width: (ft40 - 60) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 80 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 80 && ft40 > 70
                        ? {
                            width: (ft40 - 70) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 > 90 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 <= 90 && ft40 > 80
                        ? {
                            width: (ft40 - 80) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>

                <span className={`${ft40 >= 100 ? "active" : ""}`}>
                  <span
                    style={
                      ft40 < 100 && ft40 > 90
                        ? {
                            width: (ft40 - 90) * 10 + "%",
                            backgroundColor: "#e6a742",
                            border: "none",
                            height: "1.0rem",
                          }
                        : { border: "none" }
                    }
                  />
                </span>
              </div>

              <strong>
                {getCapacityUnit(data.orderType || effectiveOrderType)}{" "}
                ({ft40}%)
              </strong>
            </div>
          ))}

          {/* MORE CONTAINERS */}
          {data.foot40.length > 5 && (
            <div className="boxes">
              <div>
                <b>{data.foot40.length - 5}</b>
                <label>More Containers filled</label>
              </div>
            </div>
          )}
        </div>

        {/* FOOTER */}
        {props.showFooter && (
          <div className="boxes mt1 mb1">
            <div>
              <label>No of items - </label>
              <b>{data.itemCount}</b>
            </div>
            <div>
              <label>No of Containers - </label>
              <b>{data.foot40.length}</b>
            </div>
          </div>
        )}

        {/* STEP = 1 UI */}
        {/* Destination + PO + Date → ONLY STEP 1 */}
    {props.step === 1 && (
      <>
        {/* Destination Address */}
        <div style={{ marginTop: "10px", marginBottom: "1.5rem" }}>
          <label
            style={{
              color: "#222222",
              marginRight: "20px",
              fontWeight: 600,
            }}
          >
            Destination Address
            <span className="required-star"> *</span>
          </label>

          <select
            className="destination-dropdown"
            style={{ width: "100%", height: "30px" }}
            value={props.shippingAddresses?.[props.origin.origin_id] || ""}
            onChange={(e) => {
              const originId = props.origin.origin_id;
              props.setShippingAddresses((prev) => ({
                ...prev,
                [originId]: e.target.value,
              }));
            }}
          >
            <option value="">Select Destination</option>

            {uniqueDestinations.map((d) => (
              <option key={d.id} value={d.id}>
                {d.address1}, {d.city}, {d.zip}, {d.state || ""}
              </option>
            ))}
          </select>
          {props.originErrors?.[props.origin.origin_id]?.destination && (
              <div className="error-text">
                {props.originErrors[props.origin.origin_id].destination}
              </div>
            )}
        </div>

        {/* PO Number (Optional) */}
        <Input
          label={
            <span className="po-label-block">
              Enter your PO Number
            </span>
          }
          name="po_number"
          type="text"
          maxLength={35}
          onChange={(e) => props.setPoNumber((prev) => ({
                ...prev,
                [props.origin.origin_id]: e.target.value,
              }))
            }
          error={
            props.poNumber &&
            !regEx.test(props.poNumber) && (
              <div className="errorMsg">
                PO Number must be alphanumeric without spaces (Ex: PO01233)
              </div>
            )
          }
        />

        {/* Shipment Date */}
        <div className="date-wrap" style={{ marginBottom: "1.5rem" }}>
          <label>
            Preferred Origin Shipment Date
            <span className="required-star"> *</span>
          </label>

          <DatePicker
            className="w100"
            disabledDate={(current) =>
              current && current < moment().startOf("day")
            }
            onChange={(date) => {
            const originId = props.origin.origin_id;

              props.setShipmentDate((prev) => ({
                ...prev,
                [originId]: date
                  ? moment(date).format("YYYYMMDD")
                  : null,
              }));
            }}
          />
          {props.originErrors?.[props.origin.origin_id]?.shipmentDate && (
              <div className="error-text">
                {props.originErrors[props.origin.origin_id].shipmentDate}
              </div>
            )}
        </div>
      </>
    )}


      </div>
    );
    })()}
  </div>
);
};



const Step = Steps.Step;
const regEx = new RegExp(/^[a-zA-Z0-9]*$/);
const Cart = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart || {});
  const createOrder = useSelector((state) => state?.orders?.createOrder);
  const [poNumber, setPoNumber] = useState({});
  const [shipmentDate, setShipmentDate] = useState({});
  const [isAggree, setIsAggree] = useState(false);
  const deleteFromCart = useSelector((state) => state?.orders?.delFromCart);
  const regions = useSelector((state) => state?.orders?.origins?.data || []);
  const history = useHistory();
  const [shippingAddresses, setShippingAddresses] = useState({});
  const [isChecked, setIsChecked] = useState({});
  const origin = regions?.find((ele) => ele.id === cart?.fd_origin_id);
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const isMyOrdersReadOnly = hasOnlyView("new_order");
  const [showClearCartPopup, setShowClearCartPopup] = useState(false);
  const addressesByOrigin = useSelector((state) => state?.orders?.addresses?.data || {});
  const isPoValid = poNumber && regEx.test(poNumber);
const [showErrors, setShowErrors] = useState(false);
const [showTerms, setShowTerms] = useState(false);
const [selectedOrigins, setSelectedOrigins] = useState({});
const originsCount = cart?.line_items?.length || 0;
const isMultiOrigin = originsCount > 1;

const activeOrigins = cart?.line_items?.filter(
  (o) => selectedOrigins[o.origin_id]
) || [];

const activateOrigin = (originId) => {
  setSelectedOrigins((prev) => ({
    ...prev,
    [originId]: true,
  }));
};
const isOriginStep1Valid = (originId) =>
  !!shippingAddresses?.[originId] &&
  !!shipmentDate?.[originId];

  const [originErrors, setOriginErrors] = useState({});


const effectiveOrigins =
  activeOrigins.length > 0 ? activeOrigins : [];



const areAllDestinationsSelected = effectiveOrigins.every(
  (o) => shippingAddresses?.[o.origin_id]
);

const areAllShipmentDatesSelected = effectiveOrigins.every(
  (o) => shipmentDate?.[o.origin_id]
);

const isStep1Valid =
  areAllDestinationsSelected && areAllShipmentDatesSelected;

const hasProductsSelected = effectiveOrigins.some((o) =>
  o.items?.some((i) => Number(i.Quantity) > 0)
);

const validateSingleOriginAndSetErrors = () => {
  if (cart?.line_items?.length !== 1) return true;

  const originId = cart.line_items[0].origin_id;
  let isValid = true;

  setOriginErrors((prev) => ({
    ...prev,
    [originId]: {
      destination: !shippingAddresses?.[originId]
        ? "Destination address is required"
        : null,
      shipmentDate: !shipmentDate?.[originId]
        ? "Shipment date is required"
        : null,
    },
  }));

  if (!shippingAddresses?.[originId] || !shipmentDate?.[originId]) {
    isValid = false;
  }

  return isValid;
};

const getShippingAddressIds = (originId) => {
  const ids = [];

  // primary selected address (dropdown)
  if (shippingAddresses?.[originId]) {
    ids.push(shippingAddresses[originId]);
  }

  // other checked addresses (ONLY for this origin)
  Object.entries(isChecked?.[originId] || {}).forEach(
    ([addrId, checked]) => {
      if (checked) {
        ids.push(addrId);
      }
    }
  );

  // remove duplicates just in case
  return [...new Set(ids)];
};



//Terms can be enabled ONLY after products
const canAgreeTerms =
  isStep1Valid && hasProductsSelected;

//Final confirm enable
const canConfirmOrder =
  canAgreeTerms && isAggree;


// STEP-1 REQUIRED VALIDATIONS
const isShipmentDateValid = !!shipmentDate;

const safeLineItems =
  Array.isArray(cart?.line_items) && cart.line_items.length > 0
    ? cart.line_items
    : [
        {
          origin_id: "EMPTY",
          origin_name: "Origin Name",
          items: [],
          origin_total_quantity: 0,
          origin_total_price: 0,
        },
      ];
const isConfirmValid =
  isPoValid &&
  isShipmentDateValid &&
  areAllDestinationsSelected;
useEffect(() => {
  console.log("Selected Origins:", selectedOrigins);
}, [selectedOrigins]);


  useEffect(() => {
  if (!isStep1Valid && isAggree) {
    setIsAggree(false);
  }
}, [isStep1Valid]);


  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(customerPaymentTerms(obj));
    dispatch(customerShipmentTerms(obj));
    dispatch(get_origins(obj));
    dispatch(user_profile(obj));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
  const email = localStorage.getItem("email");
  const cartId = localStorage.getItem("cartId");

  if (email && cartId) {
    dispatch(get_cart({ email }));
  }
}, [dispatch]);

  useEffect(() => {
    if (createOrder.success) {
      toast.success("Order created.");
      //localStorage.removeItem("cartId");
      if (createOrder?.data?.meta?.cart_deleted === true) {
        localStorage.removeItem("cartId");
      }
      localStorage.getItem("cartId")
      setStep(2);
      dispatch({
        type: GetCart.RESET,
      });
      // history.push("/shop-for-tyres");
      // dispatch({
      //   type: CreateOrder.RESET,
      // });
    }
    if (createOrder.success === false) {
      toast.error(
        createOrder?.data?.error_details?.join("\n, ") ||
          "Failed to create order."
      );
      dispatch({
        type: CreateOrder.RESET,
      });
    }
    // eslint-disable-next-line
  }, [createOrder]);
    useEffect(() => {
      if (!canAgreeTerms && isAggree) {
        setIsAggree(false);
      }
    }, [canAgreeTerms]);
    useEffect(() => {
      if (cart?.line_items?.length === 1) {
        setSelectedOrigins({
          [cart.line_items[0].origin_id]: true,
        });
      }
    }, [cart]);


  useEffect(() => {
    if (deleteFromCart.success) {
      toast.success("Deleted Item.");
      dispatch(
        get_cart({
          email: localStorage.getItem("email"),
        })
      );
      if (deleteFromCart?.data?.line_items?.length === 0) {
        history.push("/shop-for-tyres");
      }
      dispatch({
        type: DeleteItemFromCart.RESET,
      });
    }
    if (deleteFromCart.success === false) {
      toast.success("Failed to delete item.");
      dispatch({
        type: DeleteItemFromCart.RESET,
      });
    }
    // eslint-disable-next-line
  }, [deleteFromCart]);

  return (
    <NavWrap>
      <div className="cart">
        <span className="close cursor">
          <img
            src={Close}
            alt="close"
            onClick={() => {
              history.goBack();
            }}
          />
        </span>
        <Steps current={step}>
          <Step
            title="Products"
            onClick={() => {
              setStep(0);
            }}
          />

          <Step
            title="Summary"
            onClick={() => {
              if (cart?.line_items?.length) setStep(1);
            }}
          />
          <Step
            title="Confirmation"
            // onClick={() => {
            //   setStep(2);
            // }}
          />
        </Steps>
        <div className="m2">
          {step === 0 && (
        <>
        <div className="header flex-between align-center mb1">
           <div>
              <h3>My Order</h3>
              <p className="note">Kindly review your order below.</p>
            </div>
                {cart?.line_items?.length > 0 && (
                  <button
                    className="primary-btn"
                    style={{ fontWeight: 600 }}
                    onClick={() => setShowClearCartPopup(true)}
                  >
                    Clear Cart
                  </button>
                )}
              </div>
              <PopupComponent open={showClearCartPopup}>
                <div className="popup-wrap">
                  <h2>
                    Are you sure you want to clear your cart?
                  </h2>
                  <div className="btns mt1">
                    <button
                      className="cancel-btn mr2"
                      onClick={() => setShowClearCartPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="save-btn"
                        onClick={() => {
                          const cartId = localStorage.getItem("cartId");
                          dispatch(clear_cart({ cartId }));
                          localStorage.removeItem("cartId");
                          dispatch({ type: GetCart.RESET });
                          setShowClearCartPopup(false);
                          toast.success("Cart cleared successfully.");
                        }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </PopupComponent>
            </>
          )}
          {step === 1 && (
            <div className="header">
              <div className="inline-hint">
                <span className="required-star" aria-hidden="true">*</span>
                <span className="hint-text">
                  {isMultiOrigin ? (
                    <> Please select <strong>Destination Address</strong> and <strong>Shipment Date</strong> to proceed with <strong>Warehouse</strong> selection.</>
                  ) : (
                    <> Please select <strong>Destination Address</strong> and <strong>Shipment Date</strong> to proceed.</>
                  )}
                </span>
          </div>
        </div>
      )}
      <PopupComponent open={showTerms} width={900}>
        <object
          data={termsNConditions}
          type="application/pdf"
          style={{ width: 860, height: 500 }}
        >
          <param name="initZoom" value="150%" />
        </object>

        <div className="flex-center mt1">
          <button
            className="primary-btn"
            onClick={() => {
            // SINGLE ORIGIN
            if (cart?.line_items?.length === 1) {
              const isValid = validateSingleOriginAndSetErrors();

              if (!isValid) {
                setShowTerms(false); // close popup
                return;
              }

              setIsAggree(true);
              setShowTerms(false);
              return;
            }

            // MULTIPLE ORIGIN (OLD behavior)
            if (!canAgreeTerms) {
              setShowTerms(false); // close popup
              toast.error("please select the warehouse");
              return;
            }

            setIsAggree(true);
            setShowTerms(false);
          }}
        >
          OK
        </button>
        </div>
      </PopupComponent>
        {step <= 1 && (
          <div className="cart-layout">
        {safeLineItems.map((originBlock, index) => {

              const isLastOrigin =
                index === safeLineItems.length - 1;

              return (
                <div className="origin-row" key={originBlock.origin_id}>
                  
                  {/* LEFT — TABLE */}
                  <div className="origin-left">
                    <Products
                      step={step}
                      isEdit={step === 0}
                      noMargin
                      originBlock={originBlock}
                      // isStep1Valid={isStep1Valid}
                        selectedOrigins={selectedOrigins}
                        setSelectedOrigins={setSelectedOrigins}
                        isOriginStep1Valid={isOriginStep1Valid}
                        setOriginErrors={setOriginErrors}
                        shippingAddresses={shippingAddresses}
                        shipmentDate={shipmentDate}
                          isChecked={isChecked}
                          setIsChecked={setIsChecked}
                    />
                  </div>

                  {/* RIGHT — CONTAINER */}
                  <div className="origin-right">
                    <ContainerStatus
                      step={step}
                      origin={originBlock}
                      showFooter
                      destinationsByOrigin={addressesByOrigin}
                      shippingAddresses={shippingAddresses}
                      setShippingAddresses={setShippingAddresses}
                      poNumber={poNumber}
                      setPoNumber={setPoNumber}
                      shipmentDate={shipmentDate}
                      setShipmentDate={setShipmentDate}
                      showErrors={showErrors}
                      isStep1Valid={isStep1Valid}
                      selectedOrigins={selectedOrigins}
                      setSelectedOrigins={setSelectedOrigins}
                      originErrors={originErrors}
                    />

                    {/*PRICE DETAILS + CONTINUE → ONLY LAST ORIGIN */}
                    {isLastOrigin && (
                      <>
                        <div className="price-details mt2" id="poNum">
                          <h3>ORDER SUMMARY</h3>

                          <div className="d-flex flex-col">
                            <span>
                              Total Order Quantity:{" "}
                              <strong>{cart?.total_quantity} pcs</strong>
                            </span>

                            <span>
                              Total Order Amount:{" "}
                              <strong>
                                $
                                {cart?.total_price
                                  ? amountFormat(cart.total_price)
                                  : 0}
                              </strong>
                            </span>
                          </div>
                        </div>

                        {step < 1 && (
                          <button
                            className="continue-btn mt1"
                            disabled={
                              isMyOrdersReadOnly || !cart?.line_items?.length
                            }
                            onClick={() => setStep(1)}
                          >
                            Continue
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
          {step === 2 && (
            <div>
              <Confirm
                resetOrder={() => {
                  dispatch({
                    type: CreateOrder.RESET,
                  });
                  dispatch({
                    type: GetCart.RESET,
                  });
                }}
              />
            </div>
          )}
        </div>
      {step === 1 && (
        <div className="confirm-bar">
          {/* Terms and Conditions */}
          <div className="diff-location">
        {isAggree ? (
          <span
            className="check"
            onClick={() => setIsAggree(false)}
          >
            <img alt="check" src={check} />
          </span>
        ) : (
          <span
            className={`uncheck ${!canAgreeTerms ? "disabled" : ""}`}
            onClick={() => {
              // SINGLE ORIGIN → new logic
              if (cart?.line_items?.length === 1) {
                const isValid = validateSingleOriginAndSetErrors();
                if (!isValid) return;
                setIsAggree(true);
                return;
              }
              //MULTIPLE ORIGIN → OLD logic (unchanged)
              if (!canAgreeTerms) {
                toast.error("please select the warehouse");
                return;
              }
              setIsAggree(true);
            }}
          />
        )}

        <p
          className={`agree-link ${!canAgreeTerms ? "disabled" : ""}`}
          onClick={() => {
            //SINGLE ORIGIN
            if (cart?.line_items?.length === 1) {
              const isValid = validateSingleOriginAndSetErrors();
              if (!isValid) return;
              setIsAggree(true);
              setShowTerms(true);
              return;
            }
            setShowTerms(true);
          }}
        >
          I Agree To The Terms and Conditions
        </p>
      </div>


          {/* RIGHT — CONFIRM */}
          <div className="confirm-wrap">
          <button
            className="confirm-btn"
            disabled={
              !canConfirmOrder ||
              createOrder?.loading ||
              cart?.line_items?.length === 0
            }
            onClick={() => {
              dispatch(
                create_orders({
                  email: localStorage.getItem("email"),
                  order_type: JSON.parse(localStorage.getItem("orderDetails"))?.order_type,
                  cart_id: localStorage.getItem("cartId"),
                  orders: effectiveOrigins.map((o) => ({
                  origin_id: o.origin_id,
                    po_number: poNumber?.[o.origin_id] || "",
                    requested_shipping_date: shipmentDate?.[o.origin_id] || "",
                    shipping_address_ids: getShippingAddressIds(o.origin_id),
                  }))

                })
              );
            }}
          >
            {createOrder?.loading ? "Processing..." : "CONFIRM ORDER"}
          </button>

          </div>
        </div>
      )}
      </div>
      <PopupComponent open={false} width="80%">
        <div className="m1">
          <ViewDetails />
        </div>
      </PopupComponent>
    </NavWrap>
  );
};

const ViewDetails = () => {
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 100,
    },
    {
      title: "Container Weight",
      children: [
        {
          title: "Gross",
          dataIndex: "gross",
          key: "gross",
          width: 80,
        },
        {
          title: "Tare",
          dataIndex: "tare",
          key: "tare",
          width: 80,
        },
        {
          title: "Net",
          dataIndex: "net",
          key: "net",
          width: 80,
        },
      ],
    },
    {
      title: "Container Measurement",
      children: [
        {
          title: "Length",
          dataIndex: "length",
          key: "length",
          width: 80,
        },
        {
          title: "Width",
          dataIndex: "width",
          key: "width",
          width: 80,
        },
        {
          title: "Height",
          dataIndex: "height",
          key: "height",
          width: 80,
        },
        {
          title: "Capacity",
          dataIndex: "capacity",
          key: "capacity",
          width: 80,
        },
      ],
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
      key: "capacity",
      width: 80,
    },
    {
      title: "Vol",
      dataIndex: "vol",
      key: "vol",
      width: 80,
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      width: 80,
    },
  ];

  const data = [];
  for (let i = 0; i < 10; i++) {
    data.push({
      key: i,
      name: "John Brown",
      age: i + 1,
      street: "Lake Park",
      building: "C",
      number: 2035,
      companyAddress: "Lake Street 42",
      companyName: "SoftLake Co",
      gender: "M",
    });
  }
  return (
    <div className="view-details">
      <h2>CARGO CONTAINER</h2>
      <span className="close">
        <img src={Close} alt="close" />
      </span>
      <Table
        columns={columns}
        dataSource={data}
        bordered
        size="middle"
        pagination={false}
      />
      <div className="flex-end mt2">
        <button className="primary-btn">Okay</button>
      </div>
    </div>
  );
};

export default Cart;
